import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppProvider } from '../../context/App';
import { Layout } from '../index';

const App = () => (
	<Router>
		<AppProvider>
			<Layout />
		</AppProvider>
	</Router>
);

export default App;
